import { render, staticRenderFns } from "./Inventorya.vue?vue&type=template&id=0cfff0ac&scoped=true&"
import script from "./Inventorya.vue?vue&type=script&lang=js&"
export * from "./Inventorya.vue?vue&type=script&lang=js&"
import style0 from "./Inventorya.vue?vue&type=style&index=0&id=0cfff0ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfff0ac",
  null
  
)

export default component.exports